module.exports = "/assets/zoom-40001e13ce917e4dd03a71c5c7bb6032.svg";